export default "__VITE_ASSET__9e14b223__"